import { Card, Col, Row } from 'react-bootstrap';

import my_activities from 'assets/img/th-each-ai/my_activities.jpg';
import courses from 'assets/img/th-each-ai/courses.jpeg';
import find_a_coach from 'assets/img/th-each-ai/find_a_coach.jpeg';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import PromptWidget from 'components/prompts/PromptWidgets';

const TrainingAndMentoring = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Learning'),
            active: true
        }
    ];

    return (
        <>
            <PageBreadcrumb items={breadcrumbItems} />
            <div className="mt-2">
                <Card className='border border-light rounded-5 mb-4' >
                    <Card.Body>
                        <div className='align-content-center '>
                            <p className="mb-0 mx-3 fs-8" style={{ 'textAlign': 'left' }}> {t("Learning.headline")}</p>
                        </div>
                    </Card.Body>
                </Card>

                <Card className='border border-light rounded-5' >
                    <Card.Body>
                        <Row>
                            <Col sm={4} md={4} lg={4}>
                                <Card onClick={() => navigate('/training/find_a_coach')} className='cursor-pointer'>
                                    <Card.Img variant="top" src={find_a_coach} />
                                    <Card.Body className='bg-theachai-tiffany'>
                                        <Card.Title className='text-white m-0 p-0 fs-7'>{t("TrainingAndMentoring.find_a_coach")}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col sm={4} md={4} lg={4}>
                                <Card onClick={() => navigate('/training/courses')} className='cursor-pointer'>
                                    <Card.Img variant="top" src={courses} />
                                    <Card.Body className='bg-theachai-yellow'>
                                        <Card.Title className='text-white m-0 p-0 fs-7'>{t("TrainingAndMentoring.my_courses")}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col sm={4} md={4} lg={4}>

                                <Card onClick={() => navigate('/training/my_activities')} className='cursor-pointer'>
                                    <Card.Img variant="top" src={my_activities} />
                                    <Card.Body className='bg-theachai-dark-blue'>
                                        <Card.Title className='text-white m-0 p-0 fs-7'>{t("TrainingAndMentoring.my_activities")}</Card.Title>
                                    </Card.Body>
                                </Card>

                                {/* 
                                <Card onClick={() => navigate('/training/resources')} className='cursor-pointer'>
                                    <Card.Img variant="top" src={resources} />
                                    <Card.Body className='bg-theachai-dark-blue'>
                                        <Card.Title className='text-white m-0 p-0 fs-7'>{t("TrainingAndMentoring.resources")}</Card.Title>
                                    </Card.Body>
                                </Card>
                            */}
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </div>
            <PromptWidget page="learning" />
        </>
    );

};

export default TrainingAndMentoring;
